import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import useBizNode from '../../useBizNode.mjs'

export default ({
    basDpId,
    basMapVerId,
    tarDpId,
    tarMapVerId,
    type,
}) => {
    const BizNode = useBizNode()

    const read = async (dpId, mapId, type) => {
        if (dpId) {
            const {
                dpContent,
                rev,
                sVer,
                [BizNode[type].textProp]: text,
            } = await BizNode[type].api.read({pkid: dpId})

            return {
                dpContent,
                text,
                ver: `${sVer}.${rev}*`,
            }
        }
        else {
            const {
                dataName,
                dataVer,
                dpContent,
                sVer,
            } = await http.get(`/basmapvers/${mapId}`)

            return {
                dpContent,
                text: dataName,
                ver: `${sVer}.${dataVer}`,
            }
        }
    }

    const {data} = useSwrNoCache(
        () => runAsync(
            async () => {
                const [left, right] = await Promise.all([
                    read(basDpId, basMapVerId, type),
                    read(tarDpId, tarMapVerId, type),
                ])

                const typeName = BizNode[type].name
                const title = `${typeName}【${left.text}】版本比对：${left.ver} VS ${right.ver}`

                return {
                    left: left.dpContent,
                    right: right.dpContent,
                    title,
                }
            },

            {action: '对比地图'}
        ),

        {
            dependencies: [
                basDpId,
                basMapVerId,
                tarDpId,
                tarMapVerId,
                type,
            ]
        }
    )

    return data
}
